// extracted by mini-css-extract-plugin
export default {"page":"NoResource_page__5hqFR","center":"NoResource_center__UAgNN"};